import React, {useEffect, useState} from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import classes from '../../InfoLinksInput/InfoLinksInput.module.css';
import ResizableIframe from "../../../UI/ResizableIframe/ResizableIFrame";
import IFrameWrapper from "../../../UI/IFrameWrapper/IFrameWrapper";
import Row from 'react-bootstrap/Row';
import {CheckCircleOutline, RemoveCircleOutline} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core"
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";


const EmbedLink = ({ index, infoLink, onInputChange, onRemoveLink, isGameLink = false }) => {
    const [originalInfoLink, setOriginalInfoLink] = useState({});
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [delIsOpen, setDelIsOpen] = useState(false)

    useEffect(() => {
        setOriginalInfoLink(infoLink);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // only run on initial render

    function isValidated(value = null) {
        if (value) {
            return value === originalInfoLink.game_embed_link
        }
        return infoLink.game_embed_link !== ''
            && infoLink.game_embed_link === originalInfoLink.game_embed_link
        // probably don't need to check if the name changes
        // && infoLink.game_name === originalInfoLink.game_name
        // && infoLink.game_embed_link_id === originalInfoLink.game_embed_link_id;
    }

    const validateJsx = <>
        {infoLink.valid && (
            <Tooltip title={"Validated"} placement={"top"}>
                <CheckCircleOutline style={{fontSize: 25}} className={classes.checkInCircle} />
            </Tooltip>
        )}
        {!infoLink.valid && !dropdownOpen &&
            <Button className="preset-modal-button-button" style={{marginLeft: 10}}
                    onClick={() => setDropdownOpen(true)}>Validate</Button>}
    </>

    const embedDropdown = <Row style={{
        display: "flex",
        justifyContent: "center", // centers the iframe horizontally
        alignItems: "center", // vertically centers the iframe
        textAlign: "center",  // centers the text content
        flexDirection: "column", // ensures the iframe and link are stacked vertically
        gap: "10px",
        paddingTop: "10px"
    }}>
        {isGameLink &&
            <ResizableIframe title={infoLink.game_name} src={infoLink.game_embed_link}
                             failContent="Embeded Game Failed to Load"
                             alwaysLoad={true}
            />}
        {!isGameLink && <div style={{maxWidth: 1024, width: "95%", alignItems: "center"}}>
            <IFrameWrapper width={"100%"} height={"100%"} src={infoLink.game_embed_link.trim() + "?border_width=0"}
                           failContent="Itch Link Failed to Load" embedItchPage={true}/>
        </div>}
        <div style={{ width: "95%", // take up full width
            display: "flex", // use flexbox to align the buttons
            justifyContent: "flex-end", // aligns buttons to the right
            gap: "10px", // adds space between buttons
            marginTop: "10px", // add some space above the buttons
            }}>
            <Button className="preset-modal-button-button"
                onClick={() => {
                setOriginalInfoLink(infoLink)
                onInputChange(index, 'valid', true, true, isGameLink ? 'GAME_EMBED' : 'ITCH_LINK');
                setDropdownOpen(false)
            }}>Confirm Embed</Button>
            <Button className="preset-modal-cancel-button" onClick={() => setDropdownOpen(false)}>Cancel</Button>
        </div>
    </Row>

    return (
        <div className={classes.infoLinksBlock} key={index}>
            <div className={classes.infoLinkField} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', width: "100%" }}>
                <Form.Control
                    as="textarea"
                    rows="1"
                    placeholder="Input the game title here"
                    value={infoLink.game_name}
                    onChange={(e) => onInputChange(index, 'game_name', e.target.value, isValidated(), isGameLink ? 'GAME_EMBED' : 'ITCH_LINK')}
                />
                 <OverlayTrigger
                trigger="click"
                rootClose
                rootCloseEvent="click"
                placement='bottom'
                onToggle={() => setDelIsOpen(false)}
                show={delIsOpen}
                overlay={<Popover id='pattern-game-description'>
                    <Popover.Content className="game-description">
                        Are you sure you want to delete this demo game?
                        <Button onClick={() => {
                            isGameLink ?
                                onRemoveLink(index, 'GAME_EMBED') :
                                onRemoveLink(index)
                        }} size={"sm"}
                                variant="primary" type="submit" className="delete-confirm-button">Delete</Button>
                    </Popover.Content>
                </Popover>}
            >
                 <Tooltip title={"Delete Game Demo"} placement={"top"}>
                     <RemoveCircleOutline style={{fontSize: 25}} className={classes.removeInCircle}
                                          onClick={() => setDelIsOpen(prev => !prev)}
                 /></Tooltip>
            </OverlayTrigger>
            </div>
            {isGameLink && (
                <div
                    className={classes.infoLinkField}
                    style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', width: "100%" }}
                >
                    <Form.Control
                        style={{
                            backgroundColor: !infoLink.valid && "#ff9797",
                            borderColor: !infoLink.valid && "red",
                            boxShadow: !infoLink.valid && "0 0 2px 4px rgba(255, 10, 10, 0.5)",
                            flex: 1, // Make the textarea take up available space
                        }}
                        as="textarea"
                        rows="1"
                        placeholder="Input the webgl embed link here"
                        value={infoLink.game_embed_link}
                        onChange={(e) =>
                            onInputChange(
                                index,
                                'game_embed_link',
                                e.target.value,
                                isValidated(e.target.value),
                                isGameLink ? 'GAME_EMBED' : 'ITCH_LINK'
                            )
                        }
                        onFocus={() => setDropdownOpen(false)}
                    />
                    {validateJsx}
                </div>
            )}
            {!isGameLink && <div className={classes.infoLinkField} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', width: "100%" }}>
                <Form.Control
                    style={{
                        backgroundColor: !infoLink.valid && "#ff9797",
                        borderColor: !infoLink.valid && "red",
                        boxShadow: !infoLink.valid && "0 0 2px 4px rgba(255, 10, 10, 0.5)",
                        flex: 1, // Make the textarea take up available space
                    }}
                    as="textarea"
                    rows="1"
                    placeholder="Input the itch page embed link here"
                    value={infoLink.game_embed_link}
                    onChange={(e) => onInputChange(index, 'game_embed_link', e.target.value, isValidated(e.target.value), isGameLink ? 'GAME_EMBED' : 'ITCH_LINK')}
                    onFocus={() => setDropdownOpen(false)}
                />
                {validateJsx}
            </div>}
            {dropdownOpen && embedDropdown}
        </div>
    );
};

export default EmbedLink;
